// extracted by mini-css-extract-plugin
module.exports = {"root":"Videos_root__2_ViU","paper":"Videos_paper__1Sg_s"};